import React, { useEffect, useState, useMemo } from "react";
import { deleteItem, fetchData } from "../utils/apiUtils";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DeleteModel from "../Components/DeleteModel";
import Spinner from "../Components/spinner";
import CustomPagination from "../helper/Pagination";
import PerPageSelect from "../Components/PerPageSelect";
import TableSearch from "../Components/TableSearch";
import dateformate from "../helper/DateFormate";

const Newsletter = () => {
  const [loading, setLoading] = useState(true);
  const [newsletterdata, setnewsletterdata] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [deleteItemId, setDeleteItemId] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const totalPages = useMemo(
    () => Math.ceil(totalCount / perPage),
    [totalCount, perPage]
  );

  useEffect(() => {
    const delay = search ? 500 : 0;
    const handler = setTimeout(() => {
      fetchnewsletterdata(currentPage, search);
    }, delay);

    return () => clearTimeout(handler);
  }, [search, perPage,currentPage]);

  const fetchnewsletterdata = async (page = 1, searchQuery = "") => {
    setLoading(true);
    const requestData = {
      perPage,
      pageNo: page,
      search: searchQuery,
    };
    await fetchData(
      "newsletter-pagination",
      requestData,
      setnewsletterdata,
      setTotalCount,
      setCurrentPage,
      setLoading
    );
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("newsletter", deleteItemId, fetchnewsletterdata);
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (err) {
      throw err;
    } finally {
      setIsDeleting(false);
    }
  };



  const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
    setCurrentPage(page);
  }
};

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5">
        <h3 className="custom-page-title">Newsletter</h3>
      </div>

      <div
        className="d-flex justify-content-between mb-2"
        style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
      >
        <PerPageSelect value={perPage} onChange={setPerPage}/>

        <div style={{ display: "flex", gap: "20px" }}>
         <TableSearch value={search} onChange={setSearch} />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <table className="custom-table table table-striped" id="usersTable">
                <thead>
                  <tr>
                    {["Email", "Updated At", "Action"].map((item, index) => (
                      <th className="font-weight-bold " key={index}>
                        {item}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="12" className="text-center">
                        <Spinner />
                      </td>
                    </tr>
                  ) : newsletterdata.length > 0 ? (
                    newsletterdata.map((item, index) => (
                      <tr key={index}>
                        <td >{item?.email}</td>
                        <td >
                          {dateformate(item?.updatedAt)}
                        </td>
                        <td >
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="edit-tooltip">Delete</Tooltip>}
                          >
                            <i
                              className="fa-solid fa-trash-can "
                              onClick={() => {
                                handleDelete(item?.id);
                              }}
                              style={{
                                cursor: "pointer",
                                color: "rgba(255, 77, 107, 1)",
                                padding: "0px 10px 1px 15px",
                                fontSize: "18px",
                                border: "none",
                              }}
                            ></i>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <h5>No data found.</h5>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            {newsletterdata?.length > 0 && (
              <div>
                <CustomPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageClick}
                  perPage={perPage}
                  totalCount={totalCount}
                />
              </div>
            )}
            </div>


          </div>


        </div>
        <DeleteModel
          deleteModalOpen={deleteModalOpen}
          setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
          onConfirm={confirmDelete}
          itemName="news-letter"
          isDeleting={isDeleting}
        />
      </div>
    </div>
  );
};

export default Newsletter;
